
import { defineComponent, computed } from "vue";

export default defineComponent({
  props: {
    modelValue: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  async setup(props, { emit }) {
    const theModel = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });
    function clearinput() {
      theModel.value = "";
    }
    return { theModel, clearinput };
  },
});
